




















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { FilterDataSingle, FilterDataMulti } from '@/store/deal'

@Component({
  name: 'FFilter'
})
export default class FFilter extends Vue {
  @Prop({
    type: String,
    required: true,
    default: null
  })
  label!: string | null

  @Prop({
    required: true
  })
  value!: Record<string, true>

  @Prop({
    required: true
  })
  items!: Record<string, FilterDataSingle | FilterDataMulti>

  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  requireIcon!: boolean

  toggle(key: string) {
    const clonedValue = { ...this.value }
    if (this.value[key]) {
      delete clonedValue[key]
      this.$emit('input', clonedValue)
      return
    }

    clonedValue[key] = true
    this.$emit('input', clonedValue)
    return
  }
}
